define([
    "dojo/_base/declare",
    "csi/authentication/AuthenticationProvider"
], function(declare,AuthenticationProvider) {

    return declare(AuthenticationProvider, {
        getFieldDefinitions: function() {
            return [
                {
                    id: "YubiKeyOTP",
                    type: "text"
                }
            ];
        }
    });
});
